import React from "react"
import styled from "styled-components"
import Page from "Components/Page"



const Collaborative = () => {
  return (
    <Page title="A collaborative project">
      <p>
        This whole project (source code included), was released under the MIT license. The Github repository is public and open to contributions. Because I would like this project to be a playground for the exploration of “DOM art”, it makes sense that anybody should be able to add his experiment / improve the concepts I originally defined. In that matter, I wrote a small documentation (see Github project) on how to create a new experiment for it to be visible on the summary. If you wish to be part of it, feel free to contribute, make a pull request, and I will eventually update this website with your work.
      </p>
      <p>
        The whole point of this project is to demonstrate how art can exist on a web document, not only as its own but also as a part of a whole. I tried not only to create fun experiments, but also to build those around more generic concepts. Because this is the web, it is fairly simple to describe the concepts in the same document as the experiments.
      </p>
    </Page>
  )
}

export default Collaborative